// extracted by mini-css-extract-plugin
export var bookingSection = "styles-module--bookingSection--3fnN8";
export var checkAvailabilityButtonSec = "styles-module--checkAvailabilityButtonSec--1vR36";
export var checkAvailabilityButton = "styles-module--checkAvailabilityButton--14364";
export var quantity = "styles-module--quantity--22pi5";
export var CheckInCheckOut = "styles-module--CheckInCheckOut--vag6j";
export var mobileBookingSection = "styles-module--mobileBookingSection--2r2zF";
export var guestsnumber = "styles-module--guestsnumber--Oouwo";
export var BookNowButtonMobile = "styles-module--BookNowButtonMobile--1Dm-5";